import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueCookies from 'vue-cookies';
import BootstrapVue from 'bootstrap-vue';
import VueAnalytics from 'vue-analytics';

import firebase from 'firebase/app';
//import * as firebase from "firebase/app";
import "firebase/firestore";
import "firebase/analytics";

import Config from '@/config/vueconfig.js';
import Validator from '@/plugins/Validator.js';
import ga from '@/plugins/GA.js';
import BBEnumCampaignType from '@/plugins/BBEnumCampaignType.js';
import RegExp from '@/plugins/RegExp.js';
import Filter from '@/plugins/Filter.js';
import Account from '@/helper/AccountHelper.js';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.config.productionTip = false
Vue.prototype.$configModalNoConnect  =  {
    title: null,
    message: "พบปัญหาการเชื่อมต่อ",
    strBtnOk: "ปิด",
    tag: "nointernet",
};
Vue.use(VueCookies);
Vue.use(Config);
Vue.use(Validator);
Vue.use(ga);
Vue.use(BBEnumCampaignType);
Vue.use(RegExp);
Vue.use(Filter);
Vue.use(BootstrapVue);

new Vue({
    router,
    render: h => h(App),
    created: function() {
        Vue.initFinished = false;

        Vue.use(VueAnalytics, {
            id: Vue.bzbsConfig.bzbsGaId,
            autoTracking: {
                page: false
            },
        });

        Account.initial();
        this.initFirebaseTracking();
    },
    methods: { 
        initFirebaseTracking: function() {
            // tutorial https://razbakov.com/vue-google-firebase-analytics/
            var config = Vue.bzbsConfig.firebase;
            if (config.apiKey) {
                firebase.initializeApp(config);
                firebase.analytics();
                Vue.prototype.$analytics = firebase.analytics();
            }
        },
    }
}).$mount('#app')
